import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const desktopClasses = {
  servicesSubMenu: css`
    padding-inline-end: ${spacing(4)}; // 32px
  `,
}
